import { createAction, props } from '@ngrx/store';

import { ApiParams } from '@shared';
import { Candidate, Company, Job } from '@shared/models';

export const layoutHeaderLoadGlobalSearch = createAction(
  '[Layout][Header Global Search] Load',
  props<{ search: string; apiParams?: ApiParams }>()
);

export const layoutHeaderLoadGlobalSearchSuccess = createAction(
  '[Layout][Header Global Search] Load Success',
  props<{
    candidates: Candidate[];
    jobs: Job[];
    companies: Company[];
  }>()
);

export const layoutHeaderLoadJobsSuccess = createAction(
  '[Layout][Header Global Search] Load Jobs Success',
  props<{ payload: { content: Job[] } }>()
);

export const layoutHeaderLoadCandidatesSuccess = createAction(
  '[Layout][Header Global Search] Load Candidates Success',
  props<{ payload: { content: Candidate[] } }>()
);

export const layoutHeaderLoadCompaniesSuccess = createAction(
  '[Layout][Header Global Search] Load Companies Success',
  props<{ payload: { content: Company[] } }>()
);

export const layoutHeaderLoadGlobalSearchFail = createAction(
  '[Layout][Header Global Search] Load Fail',
  props<{ error: any }>()
);

export const layoutHeaderClearGlobalSearch = createAction(
  '[Layout][Header Global Search] Clear',
);
